import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuService } from 'src/app/layout/app.menu.service';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.scss']
})
export class ServerErrorComponent {

  homeRoute: any;
  errorCode: any;
  errorStatus: any = {
    401: {
      title: 'Unauthorized',
      message: 'You are not authorized to access this resource.'
    },
    406: {
      title: 'Forbidden',
      message: 'You are not authorized to access this resource.'
    },
    503: {
      title: 'Server Error',
      message: 'Service Unavailable'
    },
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private menuService: MenuService,
    private router: Router
  ) {}

  ngOnInit() {
    this.homeRoute = this.menuService.homeRoute;
    this.errorCode = this.activatedRoute.snapshot.params['code'];
  }

  goHome() {
    this.router.navigate([this.homeRoute]);
  }
}
